import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import useTranslations from 'hooks/useTranslations'
import theme from 'theme'
import { DeliveryInformation } from 'utils/calculateDeliveryDate'
import useRelatedSkus from './useRelatedSkus'
import Button from 'theme/atoms/Button'
import * as configuratorEvents from 'theme/templates/OneToOneBundle/events'
import { mappings } from 'theme/templates/OneToOneBundle/utils/mappings'

type Props = {
  deliveryInformations: DeliveryInformation
}

export default function BundlerButton(props: Props) {
  const t = useTranslations<'templates-PDP'>()
  const variant = useDisplayVariant()
  const products = useRelatedSkus(variant.data)

  if (
    !variant.data.sellable ||
    !props.deliveryInformations.isBuyable ||
    !(products?.nbHits && products?.nbHits > 0)
  )
    return null

  return (
    <Wrapper
      className="BundlerButton"
      variation="cart_disabled"
      data-cy-state="show-bundler-button"
      data-cy-handle="add-to-configurator"
      $fullWidth
      to={`/one-to-one-bundle/?sku=${variant.data.sku}/`}
      onClick={() =>
        configuratorEvents.startedFrom(
          variant.data.sku,
          variant.data.related.configurableRelations
        )
      }
    >
      {variant.data.related.configurableRelations &&
        t(mappings[variant.data.related.configurableRelations[0].type])}
    </Wrapper>
  )
}

const Wrapper = styled(Button)`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  > button {
    text-align: center;
    > svg {
      height: 1rem;
      width: 1rem;
      margin-right: ${theme.spacing('xs')};
    }
    &.sold-out-button {
      cursor: not-allowed;
    }
  }
`
